<template>
    <time>
        <span class="clock__hour">{{ hours }}</span>
        <span>:</span>
        <span class="clock__minutes">{{ minutes }}</span>
        <span>:</span>
        <span class="clock__minutes">{{ seconds }}</span>
    </time>
</template>

<script>
    function padZero(number) {
        if (number < 10) {
            return "0" + number;
        }
        return number;
    }
    const getDate = (timeDiff = 0) => new Date(Date.now() - timeDiff);
    const getSeconds = (timeDiff) => padZero(getDate(timeDiff).getSeconds());
    const getMinutes = (timeDiff) => padZero(getDate(timeDiff).getMinutes());
    const getHour = (twelveHour, timeDiff) => {
        let hours = getDate(timeDiff).getHours();
        if (twelveHour && hours > 12) {
            hours = hours - 12;
        }
        return padZero(hours);
    };
    const getAmPm = (timeDiff) => (getDate(timeDiff).getHours() > 12 ? "pm" : "am");
    export default {
        name: "clock",

        props: {
            blink: Boolean,
            displaySeconds: Boolean,
            twelveHour: Boolean,
            timeDiff: Number
        },

        data() {
            return {
                ticker: null,
                minutes: getMinutes(this.timeDiff),
                hours: getHour(this.twelveHour, this.timeDiff),
                seconds: getSeconds(this.timeDiff),
                amPm: getAmPm(this.timeDiff)
            };
        },
        created() {
            this.ticker = setInterval(() => {
                this.minutes = getMinutes(this.timeDiff);
                this.hours = getHour(this.twelveHour, this.timeDiff);
                this.seconds = getSeconds(this.timeDiff);
            }, 1000);
        },
        destroyed() {
            clearInterval(this.ticker);
        }
    };
</script>

<style scoped>
</style>
